var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn btn-primary jbtn-file"},[_vm._v(_vm._s(_vm.title)),_c('input',{attrs:{"type":"file"},on:{"change":_vm.fileSelected}})])
}
var staticRenderFns = []

export { render, staticRenderFns }